import { formatVolume } from '@/lib/binary-market';

export interface SportsBlockHeaderProps {
  /** Section title, e.g. "Moneyline", "Spreads", "Totals". */
  title: string;
  /** Raw volume string for the `$… Vol.` subtitle. */
  volume: string;
}

/** Title + `$… Vol.` subtitle shown above each sports game-line block. */
export function SportsBlockHeader({ title, volume }: SportsBlockHeaderProps) {
  return (
    <div className="flex flex-col">
      <h3 className="m-0 text-[18px] font-medium text-ink">{title}</h3>
      <span className="text-[16px] text-ink-muted">${formatVolume(volume)} Vol.</span>
    </div>
  );
}
